import React from 'react'
import GenerateHtml from '../generateHtml'

const Celeron = () => {
    return (
        <div>
            < GenerateHtml 
            reviewsColor= " #334fb4"
            styles="max-width: 70%; "
            displayingHtmlFor = "Celeron"
            />
        </div>
    )
}

export default Celeron